import React from 'react';
import { useNavigate } from 'react-router-dom';
import {
  Box,
  Card,
  CardActionArea,
  CardContent,
  Grid,
  Stack,
  Typography,
} from '@mui/material';
import { Description as DescriptionIcon } from '@mui/icons-material';

interface MisInformesHubSectionProps {
  titulo: string;
  path?: string;
}

const CARD_COLOR = '#1976d2';
const CARD_ICON_BG = 'rgba(25, 118, 210, 0.1)';

const MisInformesHubSection: React.FC<MisInformesHubSectionProps> = ({
  titulo,
  path = 'personalizados',
}) => {
  const navigate = useNavigate();

  return (
    <>
      <Box sx={{ mt: 4, mb: 1.5 }}>
        <Typography variant="h6" sx={{ fontWeight: 600, color: '#1a1a1a' }}>
          Mis informes
        </Typography>
        <Typography variant="body2" color="text.secondary" sx={{ mt: 0.5 }}>
          Reportes de la biblioteca, instalables por la empresa
        </Typography>
      </Box>
      <Grid container spacing={2.5}>
        <Grid item xs={12} sm={6} md={4} lg={3}>
          <Card
            sx={{
              borderRadius: 3,
              border: '1px solid #e0e0e0',
              overflow: 'hidden',
              transition: 'all 0.3s ease',
              position: 'relative',
              height: '100%',
              minHeight: { xs: 180, sm: 195 },
              '&:hover': {
                transform: 'translateY(-4px)',
                boxShadow: '0 8px 20px rgba(0,0,0,0.12)',
                borderColor: CARD_COLOR,
              },
            }}
          >
            <CardActionArea
              onClick={() => navigate(path)}
              sx={{
                p: 0,
                height: '100%',
                alignItems: 'stretch',
                '&:hover': {
                  '& .MuiCardActionArea-focusHighlight': {
                    opacity: 0,
                  },
                },
              }}
            >
              <CardContent sx={{ p: 2.25 }}>
                <Stack spacing={1.5}>
                  <Box
                    sx={{
                      width: 48,
                      height: 48,
                      borderRadius: 2,
                      bgcolor: CARD_ICON_BG,
                      display: 'flex',
                      alignItems: 'center',
                      justifyContent: 'center',
                    }}
                  >
                    <DescriptionIcon sx={{ fontSize: 27, color: CARD_COLOR }} />
                  </Box>
                  <Typography variant="h5" sx={{ fontWeight: 600, color: '#1a1a1a', mb: 0.5 }}>
                    {titulo}
                  </Typography>
                  <Typography
                    variant="body2"
                    color="text.secondary"
                    sx={{ fontSize: '0.975rem', lineHeight: 1.6 }}
                  >
                    Instalá y ejecutá reportes de la biblioteca.
                  </Typography>
                  <Box
                    sx={{
                      display: 'flex',
                      alignItems: 'center',
                      color: CARD_COLOR,
                      fontWeight: 500,
                      fontSize: '0.85rem',
                    }}
                  >
                    Ver informe
                    <Box component="span" sx={{ ml: 1, display: 'inline-block' }}>
                      →
                    </Box>
                  </Box>
                </Stack>
              </CardContent>
            </CardActionArea>
          </Card>
        </Grid>
      </Grid>
    </>
  );
};

export default MisInformesHubSection;
